export class LoginFailure {
    public static readonly type = '[RootState] Login failure';

    constructor(public message: string) {}
}
